export const buildMemberTransactionLogUrl = (options: {
  memberId: string;
  memberName?: string | null;
  from?: string | null;
  to?: string | null;
}): string => {
  const params = new URLSearchParams({ memberId: options.memberId });
  if (options.memberName?.trim()) {
    params.set('memberName', options.memberName.trim());
  }
  const from = options.from?.trim();
  const to = options.to?.trim();
  if (from && to) {
    params.set('from', from);
    params.set('to', to);
  }
  return `/transactions?${params.toString()}`;
};
